import { render } from "./Sales_Recod_Edit.vue?vue&type=template&id=af6dded2"
import script from "./Sales_Recod_Edit.vue?vue&type=script&lang=js"
export * from "./Sales_Recod_Edit.vue?vue&type=script&lang=js"

import "./Sales_Recod_Edit.vue?vue&type=style&index=0&id=af6dded2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__